import Vue from 'vue';

export function createOutlineNavigator() {
	return new Vue({
		data() {
			return {
				headerToGo: false
			};
		},
		methods: {
			setHeaderToGo(id) {
				this.headerToGo = id;
			}
		}
	});
}
